/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_TitleInputs */

const cs_settings_teams_title = /** @type {(inputs: Settings_Teams_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týmy`)
};

const en_settings_teams_title = /** @type {(inputs: Settings_Teams_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Settings_Teams_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_title = /** @type {((inputs?: Settings_Teams_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_title(inputs)
	return cs_settings_teams_title(inputs)
});